const BUS_TICKETS = '/bus-tickets/';
const TRAIN_TICKETS = '/train-tickets/';
const FERRY_TICKETS = '/ferry-tickets/';
const FLIGHT_TICKETS = '/flight-tickets/';
const SIGN_UP = '/account/signup/';
const APP_PAGE_URL = '/app/';
const EXPLORE_PAGE_URL = '/explore/';
const NEW_ROUTES_URL = '/new-routes/';
const ABOUT_US_URL = '/about-us/';
const BLOG_URL = 'https://www.wanderu.com/blog/';
const PRESS_PAGE_URL = `${BLOG_URL}press/`;
const CAREERS_PAGE_URL = `${ABOUT_US_URL}careers/`;
const HELP_PAGE_URL = 'https://help.wanderu.com/en/';
const CARRIER_INDEX_URL = '/carrier/';
const TERMS_AND_CONDITIONS_URL = '/terms-and-conditions/';
const PRIVACY_POLICY_URL = '/privacy-policy/';

const TRAVEL_LINKS = {
    links: [
        {
            title: 'footer-bus',
            url: BUS_TICKETS,
        },
        {
            title: 'footer-train',
            url: TRAIN_TICKETS,
        },
        {
            seoHidden: true,
            title: 'footer-ferry',
            url: FERRY_TICKETS,
        },
        {
            seoHidden: true,
            title: 'footer-flight',
            url: FLIGHT_TICKETS,
        },
    ],
    title: 'footer-title-travel',
};

const ENGAGE_LINKS = {
    links: [
        {
            title: 'footer-account',
            url: SIGN_UP,
        },
        {
            title: 'footer-app',
            url: APP_PAGE_URL,
        },
        {
            title: 'footer-explore',
            url: EXPLORE_PAGE_URL,
        },
        {
            title: 'footer-routes',
            url: NEW_ROUTES_URL,
        },
    ],
    title: 'footer-title-engage',
};

const WANDERU_LINKS = {
    links: [
        {
            title: 'about-us',
            url: ABOUT_US_URL,
        },
        {
            native: true,
            title: 'blog',
            url: BLOG_URL,
        },
        {
            native: true,
            title: 'press',
            url: PRESS_PAGE_URL,
        },
        {
            native: true,
            title: 'we-are-hiring',
            url: CAREERS_PAGE_URL,
        },
    ],
    title: 'footer-title-wanderu',
};

const CUSTOMER_SERVICE_LINKS = {
    links: [
        {
            native: true,
            title: 'contact-us',
            url: HELP_PAGE_URL,
        },
        {
            title: 'footer-carrier',
            url: CARRIER_INDEX_URL,
        },
        {
            native: true,
            title: 'terms-conditions',
            url: TERMS_AND_CONDITIONS_URL,
        },
        {
            native: true,
            title: 'privacy-policy',
            url: PRIVACY_POLICY_URL,
        },
    ],
    title: 'footer-title-customer-service',
};

const LINK_SECTION = [
    {
        sectionLinks: TRAVEL_LINKS.links,
        sectionTitle: TRAVEL_LINKS.title,
    },
    {
        sectionLinks: ENGAGE_LINKS.links,
        sectionTitle: ENGAGE_LINKS.title,
        seoHidden: true,
    },
    {
        sectionLinks: WANDERU_LINKS.links,
        sectionTitle: WANDERU_LINKS.title,
    },
    {
        sectionLinks: CUSTOMER_SERVICE_LINKS.links,
        sectionTitle: CUSTOMER_SERVICE_LINKS.title,
    },
];

export {
    LINK_SECTION,
};
